import React from 'react';
import { NavLink } from 'react-router-dom';
import { USE_CASE_NAV_TOP, USE_CASE_SECTIONS } from '../../data/useCases/useCasesConfig';

function WorkflowIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default function UseCasesMenu({ onNavigate }) {
    const close = () => {
        if (onNavigate) onNavigate();
    };

    return (
        <>
            <NavLink to={USE_CASE_NAV_TOP.to} className="dropdown-item" onClick={close}>
                <div className="dropdown-item-content">
                    <div className="dropdown-item-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8 7h8M8 11h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="dropdown-item-text">
                        <div className="dropdown-item-title">{USE_CASE_NAV_TOP.title}</div>
                        <div className="dropdown-item-description">{USE_CASE_NAV_TOP.description}</div>
                    </div>
                </div>
            </NavLink>
            {USE_CASE_SECTIONS.map((section) => (
                <React.Fragment key={section.key}>
                    <div className="topnav-dropdown-section-label" role="presentation">
                        {section.label}
                    </div>
                    {section.items.map((item) => (
                        <NavLink key={item.slug} to={item.path} className="dropdown-item" onClick={close}>
                            <div className="dropdown-item-content">
                                <div className="dropdown-item-icon">
                                    <WorkflowIcon />
                                </div>
                                <div className="dropdown-item-text">
                                    <div className="dropdown-item-title">{item.navTitle}</div>
                                    <div className="dropdown-item-description">{item.description}</div>
                                </div>
                            </div>
                        </NavLink>
                    ))}
                </React.Fragment>
            ))}
        </>
    );
}
